module.exports = __webpack_public_path__ + "img/cangku.0dbea0b3.png";